import { __assign } from "tslib";
import React, { memo } from 'react';
import cx from 'classnames';
import Highlighter from 'react-highlight-words';
import isEqual from 'react-fast-compare';
import Checkbox from '@mercell/checkbox-react';
import RadioButton from '@mercell/radio-button-react';
import { pickProperNodeIcon } from './utlis';
var cpvPadding = function (parentsLength) {
    switch (parentsLength) {
        case 1:
            return 'pl-8';
        case 2:
            return 'pl-16';
        case 3:
            return 'pl-24';
        case 4:
            return 'pl-32';
        case 5:
            return 'pl-40';
        case 6:
            return 'pl-48';
        case 7:
            return 'pl-56';
        case 8:
            return 'pl-64';
        case 9:
            return 'pl-72';
        default:
            return '';
    }
};
export var CPVRow = memo(function (_a) {
    var data = _a.data, index = _a.index, style = _a.style;
    var codesToRender = data.codesToRender, cpvCodes = data.cpvCodes, selectedCodes = data.selectedCodes, ariaCollapseChevronLabel = data.ariaCollapseChevronLabel, ariaExpandChevronLabel = data.ariaExpandChevronLabel, searchValue = data.searchValue, toggleParentExpand = data.toggleParentExpand, toggleSelectedCodesRadio = data.toggleSelectedCodesRadio, toggleSelectedCodesCheckbox = data.toggleSelectedCodesCheckbox, selectedParentToExpand = data.selectedParentToExpand, allowToSelectOnlyOne = data.allowToSelectOnlyOne, disabledCPVs = data.disabledCPVs;
    var code = codesToRender[index];
    var _b = cpvCodes[code], description = _b.description, children = _b.children, parents = _b.parents;
    var isSelected = selectedCodes.includes(code);
    var isDisabled = disabledCPVs === null || disabledCPVs === void 0 ? void 0 : disabledCPVs.includes(code);
    var chevronAriaProps = {};
    if (children.length > 0) {
        if (selectedParentToExpand.includes(code)) {
            chevronAriaProps = {
                'aria-expanded': 'true',
                'aria-label': "".concat(ariaCollapseChevronLabel, " ").concat(code, " ").concat(description),
            };
        }
        else {
            chevronAriaProps = {
                'aria-expanded': 'false',
                'aria-label': "".concat(ariaExpandChevronLabel, " ").concat(code, " ").concat(description),
            };
        }
    }
    var Controller = allowToSelectOnlyOne ? RadioButton : Checkbox;
    var leftNodeIcon = pickProperNodeIcon(selectedParentToExpand, code, !!searchValue, children.length);
    var toggleParentExpandAction = children.length
        ? toggleParentExpand
        : undefined;
    return (React.createElement("div", { style: __assign(__assign({}, style), { width: 'unset' }), key: "option-".concat(index), className: cx('flex items-center', parents.length ? cpvPadding(parents.length) : 'pl-2') },
        searchValue || children.length === 0 ? (leftNodeIcon) : (React.createElement("button", __assign({}, chevronAriaProps, { key: code, type: "button", "data-code": code, onClick: toggleParentExpandAction }), leftNodeIcon)),
        React.createElement(Controller, { id: "cpv-".concat(code), name: allowToSelectOnlyOne
                ? 'cpv-code-radio'
                : 'cpv-code-checkbox', onChange: allowToSelectOnlyOne
                ? toggleSelectedCodesRadio
                : toggleSelectedCodesCheckbox, disabled: isDisabled, "data-code": code, checked: isSelected, "aria-label": "".concat(code, " ").concat(description), className: "text-caption", labelProps: {
                className: 'pl-2 whitespace-nowrap overflow-auto',
            } },
            React.createElement(Highlighter, { highlightClassName: "rounded-half bg-studio text-white", searchWords: [searchValue], textToHighlight: "".concat(code, " ").concat(description) }))));
}, isEqual);
CPVRow.displayName = 'Row';
